import { render, staticRenderFns } from "./SmallLoader.vue?vue&type=template&id=6d261dc8&"
import script from "./SmallLoader.vue?vue&type=script&lang=js&"
export * from "./SmallLoader.vue?vue&type=script&lang=js&"
import style0 from "./SmallLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports